// extracted by mini-css-extract-plugin
export default {"profileCard":"UserProfile_profileCard__Zvziu","coursesEnrolled":"UserProfile_coursesEnrolled__2fr3e","gridWrapper":"UserProfile_gridWrapper__fDfKt"};